// extracted by mini-css-extract-plugin
export default {"title":"style_title__Zg1sA","skillsdiv":"style_skillsdiv__xKGCT"};